import { render, staticRenderFns } from "./timeLabel.vue?vue&type=template&id=767f01d8&scoped=true&"
import script from "./timeLabel.vue?vue&type=script&lang=ts&"
export * from "./timeLabel.vue?vue&type=script&lang=ts&"
import style0 from "./timeLabel.vue?vue&type=style&index=0&id=767f01d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767f01d8",
  null
  
)

export default component.exports